/**
 * The companion's words on the page (ADR-142 decision 6 and the coordinator's ruling of 2026-10-31 on his name, P2.26-T6),
 * every one a draft for the author: the words over him while the pointer is on him. `{owner}` is the player's first name,
 * which is all a watcher holds; a companion's own name reaches his owner alone. The control that sends him out or home is
 * the character window's Companions tab, built by its own row.
 */
export const COMPANION = {
  hover: "{owner}'s Aethling",
  fallbackName: "Your Aethling",
} as const;
